import React, { useEffect, useState } from "react";
import "./App.css";
import Login from "./pages/Login";
import Choose from "./pages/Choose";
import Chatting from "./pages/Chatting";
import { UserInfo } from "./interfaces/chat.interface";

function App() {
  const [page, setPage] = useState<number>(0); // 0: 로그인, 1: 캐릭터 선택, 2: 채팅
  const [loginId, setLoginId] = useState<number>(0);
  const [selectedCharacter, setSelectedCharacter] = useState<UserInfo>({
    userId: 0,
    nickname: "",
    characterImageUrl: "",
  });

  useEffect(() => {
    if (page === 1 || page === 2) {
      const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        e.preventDefault();
        e.returnValue = "";

        // beforeunload 이벤트에서는 confirm을 직접 사용할 수 없으므로,
        // 사용자가 페이지를 떠날 때 세션스토리지를 정리합니다
        const cleanup = () => {
          sessionStorage.removeItem("id");
          sessionStorage.removeItem("idData");
          sessionStorage.removeItem("charactersData");
        };

        // 페이지 언로드 시 cleanup 실행
        window.addEventListener("unload", cleanup, { once: true });

        return "새로고침 시, 로그아웃됩니다. 계속 하시겠습니까?";
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [page]);

  return (
    <>
      {page === 0 && <Login setPage={setPage} setLoginId={setLoginId} />}
      {page === 1 && (
        <Choose
          setPage={setPage}
          loginId={loginId}
          setLoginId={setLoginId}
          setSelectedCharacter={setSelectedCharacter}
        />
      )}
      {page === 2 && (
        <Chatting
          setPage={setPage}
          loginId={loginId}
          selectedCharacter={selectedCharacter}
          setSelectedCharacter={setSelectedCharacter}
        />
      )}
    </>
  );
}

export default App;
